import { render, staticRenderFns } from "./tableRow.vue?vue&type=template&id=2ccf333f&"
import script from "./tableRow.vue?vue&type=script&lang=ts&"
export * from "./tableRow.vue?vue&type=script&lang=ts&"
import style0 from "./tableRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports